import { Popover } from "@mui/material"

export const PopoverList = (props) => {

    const {
        open,
        idx,
        anchorEl,
        handleClose,
        list_options
    } = props

    return (
        <Popover
            className='p-popover-share'
            id={idx}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <div className='options'>

                {list_options?.map(it => {
                    return it.show && (
                        <button key={it.id} onClick={it.handleFn}>
                            <i className={it.icon_class} style={{ color: it?.icon_color || '' }}></i>
                            <span style={{ fontSize: '12px' }}>{it.name}</span>
                        </button>
                        // <a key={it.id} onClick={it.handleFn} href="">
                        //     <i className={it.icon_class} style={{ color: it?.icon_color || '' }}></i>
                        //     <span style={{ fontSize: '12px' }}>{it.name}</span>
                        // </a>
                    )
                })}

                {/* <a href="#" onClick={shareExcel}>
                    <i className="bi bi-file-earmark-excel"></i>
                    <span style={{ fontSize: '12px' }}>EXCEL</span>
                </a>

                <a href="#" onClick={sharePdf}>
                    <i className="bi bi-filetype-pdf"></i>
                    <span style={{ fontSize: '12px' }}>PDF</span>
                </a>

                {(parseFloat(idEmpPro) === 15 || parseFloat(idEmpPro) === 4) &&
                    <a href="#" onClick={sharePdfNP}>
                        <i className="bi bi-filetype-pdf"></i>
                        <span style={{ fontSize: '12px' }}>NP</span>
                    </a>
                } */}

            </div>
        </Popover>
    )
}